import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { handleError } from "../utilities/api.utils";

@Injectable({
  providedIn: "root",
})
export class GetModalPayloadService {
  constructor(private http: HttpClient) {}

  public getModalPayload(
    operation: string,
    accountNumber: string
  ): Observable<ModalResponsePayload> {
    const body = {
      accountNumber,
      operation,
    };

    return this.http
      .post<ModalResponsePayload>(
        environment.moeUserApiProxyUrl + "/payments/payment-modal",
        body
      )
      .pipe(catchError(handleError));
  }
}

export interface ModalResponsePayload {
  accessTokenId: string;
  sessionId: string;
  error?: string;
}
